"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { renderValueWithVariables } from "../VariablePill";
interface MathOperationPayloadProps {
  left?: unknown;
  operator?: unknown;
  right?: unknown;
  rounding?: unknown;
}

/**
 * MathOperationPayload - Component for rendering math operation workflow steps
 * Displays mathematical operations in an intuitive, formatted way with variable pills
 */
export function MathOperationPayload(t0) {
  const $ = _c(17);
  const {
    left,
    operator,
    right,
    rounding
  } = t0;
  const hasRounding = Boolean(rounding && rounding !== "none");
  let t1;
  if ($[0] !== hasRounding || $[1] !== rounding) {
    t1 = hasRounding && <span className="text-ds-text-subtle dark:text-ds-text-disabled">{String(rounding)}(</span>;
    $[0] = hasRounding;
    $[1] = rounding;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== left) {
    t2 = renderValueWithVariables(left);
    $[3] = left;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = String(operator);
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="text-ds-text-secondary px-0.5">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== right) {
    t5 = renderValueWithVariables(right);
    $[7] = right;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== hasRounding) {
    t6 = hasRounding && <span className="text-ds-text-subtle dark:text-ds-text-disabled">)</span>;
    $[9] = hasRounding;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <div className="border-ds-border-default border-t pt-3"><div className="flex flex-wrap items-center gap-1.5 font-mono text-xs">{t1}{t2}{t4}{t5}{t6}</div></div>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}